/**
 * Shared carousel DOM queries, mobile-only activation, px track step.
 */

import { $$ } from '../utils';

export const CAROUSEL_CONTAINER_SELECTOR = '.carousel, .carousel--arrows, .carousel--how, [data-mobile-only="1"]';

/** Carousels that re-sync slide position on resize (testimonials + job postings). */
export const FIXED_STEP_RESYNC_SELECTOR = '[data-mobile-only="1"], .testimonials-carousel';

const cssLengthToPx = (element, value) => {
    const trimmed = (value || '').trim();
    if (!trimmed) return 0;
    if (trimmed.endsWith('px')) return parseFloat(trimmed);

    const rootPx = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
    if (trimmed.endsWith('rem')) return parseFloat(trimmed) * rootPx;
    if (trimmed.endsWith('em')) {
        return parseFloat(trimmed) * (parseFloat(getComputedStyle(element).fontSize) || rootPx);
    }

    return parseFloat(trimmed) || 0;
};

export const getBreakpoint = (container) => parseInt(container.getAttribute('data-mobile-breakpoint') || '768', 10);

/** Mobile-only carousels are inactive above data-mobile-breakpoint unless .carousel is toggled on. */
export const isActiveCarousel = (container) =>
    container.getAttribute('data-mobile-only') !== '1' ||
    (window.innerWidth <= getBreakpoint(container) && container.classList.contains('carousel'));

export const toggleMobileCarousels = () => {
    $$('[data-mobile-only="1"]').forEach((container) => {
        container.classList.toggle('carousel', window.innerWidth <= getBreakpoint(container));
    });
};

export const getFixedStepCarouselTrackStep = (track, slides) => {
    const styles = getComputedStyle(track);
    const gapValue =
        styles.getPropertyValue('--testimonials-carousel-gap').trim() ||
        styles.getPropertyValue('--job-postings-carousel-gap').trim() ||
        styles.columnGap ||
        styles.gap;

    return (slides[0]?.offsetWidth || track.clientWidth) + cssLengthToPx(track, gapValue);
};
